// Credit App Action Types
export const INITIALIZE_CREDIT_APP = 'INITIALIZE_CREDIT_APP';
export const SUBMIT_CREDIT_APP = 'SUBMIT_CREDIT_APP';
export const RESET_CREDIT_APP = 'RESET_CREDIT_APP';
